import { render, staticRenderFns } from "./ActiveChats.vue?vue&type=template&id=06fe5003&scoped=true&"
import script from "./ActiveChats.vue?vue&type=script&lang=js&"
export * from "./ActiveChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe5003",
  null
  
)

export default component.exports